<template>
	<div>
		<div class="page-header">
			<v-img src="@/assets/img/page-header-bg.jpeg" position="center"></v-img>
			<div class="page-title" v-if="pageData">
				<h1>{{ pageData.title }}</h1>
			</div>
		</div>
		<v-container class="py-16">
			<div class="fill-height w-100 d-flex align-center justify-center" v-if="loading">
				<v-progress-circular
					indeterminate
					color="primary"
				></v-progress-circular>
			</div>
			<div v-else>
				<v-row>
					<v-col sm="6" cols="12">
						<div v-html="pageData.content"></div>
					</v-col>
					<v-col sm="6" cols="12">

					</v-col>
				</v-row>
			</div>
		</v-container>
	</div>
</template>

<script>
export default {
	name: "Default",
	data: () => ({
		pageData: null,
		loading: true,
	}),
	mounted(){
		this.$axios.get(`site/pages/iletisim`)
		.then(({ data }) => {
			this.pageData = data
		})
		.catch(() => this.$router.push({ name: 'Home' }))
		.finally(() => this.loading = false)
	},
}
</script>

<style scoped lang="scss">
.page-header {
	height: 200px;
	overflow: hidden;
	position: relative;
	&:after {
		position: absolute;
		inset: 0;
		background-color: rgba(255,255,255,.5);
		display: block;
		content: "";
		z-index: 0;
	}
	.page-title {
		position: absolute;
		inset: 0;
		display: flex;
		align-items: center;
		justify-content: center;
		z-index: 10;
	}
}
</style>